import DepositForm from './deposit-form';

export default DepositForm;
